import {Configuration, Token} from "@devour/client";
import {store} from "@/redux";

export default function getConfig(fullToken?: Token, basePath?: string): Configuration {
    const _fullToken = fullToken || store.getState().authStore.fullToken;

    const headers = _fullToken?.token
        ? {headers: {authorization: `Bearer ${_fullToken?.token}`}}
        : {};

    // Always provide basePath from environment variable or parameter
    const finalBasePath = basePath || import.meta.env.VITE_BACKEND_REST_URL;

    if (!finalBasePath) {
        throw new Error("VITE_BACKEND_REST_URL environment variable is not set. Please check your .env file.");
    }

    return new Configuration({
        ...headers,
        basePath: finalBasePath,
    });
}

export function getMagicConfig(magicCredential: string): Configuration {
    if (!import.meta.env.VITE_BACKEND_REST_URL) {
        throw new Error("VITE_BACKEND_REST_URL environment variable is not set. Please check your .env file.");
    }
    return new Configuration({
        headers: {
            "authorization": `Bearer ${magicCredential}`,
        },
        basePath: import.meta.env.VITE_BACKEND_REST_URL,
    });
}